import { stringToHexColor } from '@/functions/hsl-color-generator'

export function avatarGenerator (name?: string | null, background?: string | null, color?: string | null) {
  const bg =
    '&background=' + (background ?? stringToHexColor(name ?? ''))
  const cl = '&color=' + (color ?? 'fff')
  const nm = '&name=' + name
  return 'https://ui-avatars.com/api/?rounded=true' + bg + cl + nm
}
